import { Box } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { PropsWithChildren, useMemo } from 'react';
import { Chapter } from '../types';
import { useChapterColors } from '../hooks';

export interface BackgroundGradientProps extends PropsWithChildren, Chapter {
	gradientHeight?: number;
	endBackgroundColor?: string;
	sx?: SxProps;
}

export const BackgroundGradient = ({
	children,
	chapter,
	endBackgroundColor,
	gradientHeight,
	sx
}: BackgroundGradientProps) => {
	const { solidBg } = useChapterColors();

	const backgroundColor = useMemo(() => {
		return solidBg(chapter);
	}, [chapter, solidBg]);

	return (
		<Box
			sx={{
				background: `linear-gradient(180deg, ${backgroundColor}, ${
					endBackgroundColor ? endBackgroundColor : '#ffffff'
				} ${gradientHeight ? `${gradientHeight}px` : '100%'})`,
				...sx
			}}
		>
			{children}
		</Box>
	);
};
